import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      color: var(--card-muted-fg-color);\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      color: var(--card-accent-fg-color);\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    text-transform: uppercase;\n\n    &:before {\n      content: '';\n      display: block;\n      height: 0;\n    }\n\n    &:after {\n      content: '';\n      display: block;\n      height: 0;\n    }\n\n    ", "\n\n    ", "\n\n    & code {\n      font-family: ", ";\n      border-radius: 1px;\n    }\n\n    & a {\n      text-decoration: none;\n      border-radius: 1px;\n    }\n\n    & [data-sanity-icon] {\n      vertical-align: baseline;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
export function labelBaseStyles(props) {
  var accent = props.accent,
      theme = props.theme,
      muted = props.muted;
  return css(_templateObject(), accent && css(_templateObject2()), muted && css(_templateObject3()), theme.sanity.fonts.code.family);
}